/**
 * Created by dvircohen on 21/09/2016.
 */
(function () {
    'use strict';

    // @ngInject
    function QuestionnaireTemplateEmptyStateControllerCtor($scope, $injector, AnalyticsService, TemplatesViewService, $state, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'QuestionnaireTemplateEmptyStateController';
        AnalyticsService.trackPageView(this, 'QuestionnaireTemplateEmptyStateView');

        this.TemplatesViewService = TemplatesViewService;
        this.$state = $state;
        this.AppStates = AppStates;
    }

    Controllers.QuestionnaireTemplateEmptyStateController = Class(Controllers.BaseController, {
        constructor: QuestionnaireTemplateEmptyStateControllerCtor
    });
}());

